module.exports = "/_next/static/images/offers4-e393ea855dddb8f501fef94a00cd7b91.jpg.webp";